// extracted by mini-css-extract-plugin
module.exports = {"techSpecsTabPane":"TechSpecsTab_techSpecsTabPane__k19tv","pdp-footnotes":"TechSpecsTab_pdp-footnotes__Rgz58","pdp-footnotes-text":"TechSpecsTab_pdp-footnotes-text__FvKrP"};